(() => {
  document.querySelectorAll('.b2b-contact__form > .b2b-contact__receipt').forEach((notice) => {
    setTimeout(() => notice.remove(), 5000);
  });
  if (customElements.get('b2b-form-feedback')) return;

  class B2bFormFeedback extends HTMLElement {
    connectedCallback() {
      this.submitted = false;
      this.completed ??= false;
      this.attempts = 0;
      this.connectForm();
    }

    disconnectedCallback() {
      clearTimeout(this.connectTimer);
      this.observer?.disconnect();
      this.formRoot?.removeEventListener('submit', this.onSubmit, true);
    }

    connectForm() {
      if (!this.isConnected) return;
      const root = this.querySelector('shopify-forms-embed')?.shadowRoot;
      const form = root?.querySelector('form[data-testid="form"]');
      if (!form) {
        if (this.attempts++ < 100) this.connectTimer = setTimeout(() => this.connectForm(), 100);
        return;
      }

      this.formRoot = root;
      this.onSubmit = () => {
        this.submitted = true;
      };
      root.addEventListener('submit', this.onSubmit, true);
      this.observer = new MutationObserver(() => this.onFormChange());
      this.observer.observe(root, { childList: true, subtree: true });
      this.syncFieldErrors();
    }

    onFormChange() {
      this.syncFieldErrors();
      // This banner is rendered by Shopify Forms only after its successful response.
      // Keep the app's submission/storage flow; replace only its confirmation UI.
      if (!this.submitted || this.completed || !this.formRoot.querySelector('[data-testid="banner-success"]')) return;
      this.completed = true;
      this.trackLead();
      const notice = this.querySelector('.b2b-contact__success');
      const app = this.querySelector('.b2b-contact__embed');
      if (!notice || !app) return;
      app.hidden = true;
      notice.hidden = false;
      notice.focus({ preventScroll: true });
      notice.scrollIntoView({ block: 'nearest', behavior: 'instant' });
    }

    trackLead() {
      const send = () => {
        try {
          if (this.leadSent || window.Shopify?.customerPrivacy?.marketingAllowed?.() !== true) return;
          this.leadSent = true;
          const pixelId = '1642603806774287';
          if (typeof window.fbq !== 'function') {
            const fbq = function () {
              if (fbq.callMethod) fbq.callMethod.apply(fbq, arguments);
              else fbq.queue.push(arguments);
            };
            fbq.queue = [];
            fbq.push = fbq;
            fbq.loaded = true;
            fbq.version = '2.0';
            window.fbq = fbq;
            window._fbq = window._fbq || fbq;
          }
          window.fbq('set', 'autoConfig', false, pixelId);
          const pixels = window.fbq.getState?.()?.pixels || [];
          if (!pixels.some(pixel => String(pixel.id) === pixelId)) window.fbq('init', pixelId);
          window.fbq('trackSingle', pixelId, 'Lead', {
            content_name: 'Santa TOEFL B2B inquiry',
            content_category: 'B2B'
          });
          const src = 'https://connect.facebook.net/en_US/fbevents.js';
          if (!window.fbq.callMethod && !document.querySelector(`script[src="${src}"]`)) {
            const script = document.createElement('script');
            script.async = true;
            script.src = src;
            document.head.appendChild(script);
          }
        } catch {
          // Tracking must never interrupt the successful form confirmation.
        }
      };
      try {
        if (typeof window.Shopify?.customerPrivacy?.marketingAllowed === 'function') send();
        else window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], error => {
          if (!error) send();
        });
      } catch {
        // Keep the native completion flow if the privacy API is unavailable.
      }
    }

    syncFieldErrors() {
      const fields = this.formRoot.querySelectorAll('form[data-testid="form"] > div');
      fields.forEach((container) => {
        const control = container.querySelector('input, textarea, button[aria-labelledby]');
        if (!control) return;
        const error = container.nextElementSibling;
        const errorId = `b2b-error-${encodeURIComponent(control.id || control.name || control.getAttribute('aria-labelledby'))}`;
        const descriptions = (control.getAttribute('aria-describedby') || '').split(/\s+/).filter((id) => id && id !== errorId);
        if (error?.matches('output[role="alert"]')) {
          if (error.id !== errorId) error.id = errorId;
          descriptions.push(errorId);
        }
        const description = descriptions.join(' ');
        if (description && control.getAttribute('aria-describedby') !== description) control.setAttribute('aria-describedby', description);
        else if (!description && control.getAttribute('aria-describedby')) control.removeAttribute('aria-describedby');
        // The app's textarea label has a for attribute but no matching control ID.
        const label = container.querySelector('label[for]');
        if (!control.id && label) control.id = label.htmlFor;
      });
    }

  }

  customElements.define('b2b-form-feedback', B2bFormFeedback);
})();
